import classnames from 'classnames';

import style from './style.module.less';

import type { CollapsibleListSectionSubHeaderComponent } from './collapsible-list-section-sub-header-types';

export const CollapsibleListSectionSubHeader: CollapsibleListSectionSubHeaderComponent = ({ children, className = null }) => {
  return <div className={classnames(style['collapsible-list-section-sub-header'], className)}>{children}</div>;
};
